/**
 * Gestione Mense Backend Authentication API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * Tipi di evento calendario. Tipi previsti:   -*ATTIVO*  -*CANCELLATO*
 */
export type EventoCalendarioStatus = 'ATTIVO' | 'CANCELLATO';

export const EventoCalendarioStatus = {
    ATTIVO: 'ATTIVO' as EventoCalendarioStatus,
    CANCELLATO: 'CANCELLATO' as EventoCalendarioStatus
};